import React, { useEffect, useState } from "react";
import { useIntl } from "gatsby-plugin-intl";
import { cn } from "@sys42/utils";
// import { } from '../../system42'
import * as styles from "./styles.module.css";

export function NotTranslatedInfoBox(props) {
  const { className, ...containerProps } = props;

  const intl = useIntl();
  const [notTranslatedBoxHidden, setNotTranslatedBoxHidden] = useState(false);

  useEffect(() => {
    function handleWindowScroll() {
      setNotTranslatedBoxHidden(true);
    }
    window.addEventListener("scroll", handleWindowScroll);
    return () => {
      window.removeEventListener("scroll", handleWindowScroll);
    };
  }, []);

  return (
    <div
      className={cn(
        className,
        styles.notTranslatedInfoBox,
        notTranslatedBoxHidden && styles.notTranslatedInfoBox_hidden
      )}
      {...containerProps}
    >
      <span role="img" aria-label="Info">
        ℹ️
      </span>
      <div className={styles.content}>
        {" "}
        {intl.formatMessage({ id: "messages.notTranslatedInfoBox" })}
      </div>
      <button
        className={styles.closeButton}
        type={"button"}
        onClick={() => setNotTranslatedBoxHidden(true)}
      >
        close
      </button>
    </div>
  );
}
